<div class="workspace-switcher" (click)="$event.stopPropagation()">
  <!-- Elegant Workspace Trigger -->
  <div class="workspace-trigger" (click)="toggleDropdown()" [class.active]="isDropdownOpen">
    <div class="workspace-avatar">
      <img *ngIf="currentWorkspace?.logo" [src]="currentWorkspace.logo" [alt]="getWorkspaceDisplayName(currentWorkspace)" class="avatar-image" />
      <div *ngIf="!currentWorkspace?.logo" class="avatar-fallback">
        {{ getWorkspaceInitials(currentWorkspace) }}
      </div>
    </div>
    <div class="workspace-details">
      <span class="workspace-name">{{ getWorkspaceDisplayName(currentWorkspace) }}</span>
      <span class="workspace-meta" *ngIf="currentWorkspace?.slug">{{ currentWorkspace.slug }}</span>
    </div>
    <div class="dropdown-arrow" [class.open]="isDropdownOpen">
      <svg viewBox="0 0 24 24">
        <path d="M7,10L12,15L17,10H7Z" />
      </svg>
    </div>
  </div>

  <!-- Seamless Connected Dropdown -->
  <div class="workspace-dropdown" [class.open]="isDropdownOpen" *ngIf="isDropdownOpen">
    <!-- Compact Search Section -->
    <div class="search-section">
      <div class="search-input-wrapper">
        <svg class="search-icon" viewBox="0 0 24 24">
          <path
            d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
          />
        </svg>
        <input #searchInput type="text" placeholder="Find workspace..." [(ngModel)]="searchTerm" (input)="onSearchInput($event)" class="search-input" />
        <div class="search-clear" *ngIf="searchTerm" (click)="clearSearch()">
          <svg viewBox="0 0 24 24">
            <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
          </svg>
        </div>
      </div>
    </div>

    <!-- Elegant Workspace List -->
    <div class="workspaces-container" (scroll)="onScroll($event)">
      <!-- Current Workspace - Special Treatment -->
      <div class="current-workspace-section">
        <div class="workspace-item current" (click)="closeDropdown()">
          <div class="workspace-avatar">
            <img *ngIf="currentWorkspace?.logo" [src]="currentWorkspace.logo" [alt]="getWorkspaceDisplayName(currentWorkspace)" class="avatar-image" />
            <div *ngIf="!currentWorkspace?.logo" class="avatar-fallback">
              {{ getWorkspaceInitials(currentWorkspace) }}
            </div>
          </div>
          <div class="workspace-info">
            <div class="workspace-name">{{ getWorkspaceDisplayName(currentWorkspace) }}</div>
            <div class="workspace-meta">
              <span class="workspace-slug" *ngIf="currentWorkspace?.slug">{{ currentWorkspace.slug }}</span>
              <span class="current-badge">Current</span>
            </div>
          </div>
          <div class="workspace-status">
            <div class="status-indicator current"></div>
          </div>
        </div>
      </div>

      <!-- Elegant Divider -->
      <div class="elegant-divider" *ngIf="filteredWorkspaces.length > 0">
        <div class="divider-line"></div>
        <span class="divider-text">Switch to</span>
        <div class="divider-line"></div>
      </div>

      <!-- Available Workspaces with Stunning Design -->
      <div class="available-workspaces" *ngIf="filteredWorkspaces.length > 0">
        <div
          class="workspace-item"
          *ngFor="let workspace of filteredWorkspaces; trackBy: trackByWorkspaceId"
          [class.current]="isCurrentWorkspace(workspace)"
          (click)="switchWorkspace(workspace)"
        >
          <div class="workspace-avatar">
            <img *ngIf="workspace.logo" [src]="workspace.logo" [alt]="getWorkspaceDisplayName(workspace)" class="avatar-image" (error)="onImageError($event)" />
            <div *ngIf="!workspace.logo" class="avatar-fallback">
              {{ getWorkspaceInitials(workspace) }}
            </div>
          </div>
          <div class="workspace-info">
            <div class="workspace-name">{{ getWorkspaceDisplayName(workspace) }}</div>
            <div class="workspace-meta">
              <span class="workspace-slug" *ngIf="workspace.slug">{{ workspace.slug }}</span>
              <div class="workspace-badges" *ngIf="workspace.role || workspace.events_count !== undefined">
                <span class="role-badge" [class]="'role-' + workspace.role?.name?.toLowerCase()" *ngIf="workspace.role">
                  {{ workspace.role.name }}
                </span>
                <span class="events-badge" *ngIf="workspace.events_count !== undefined">
                  {{ workspace.events_count }} {{ workspace.events_count === 1 ? 'event' : 'events' }}
                </span>
              </div>
            </div>
          </div>
          <div class="workspace-actions">
            <div class="switch-indicator">
              <svg viewBox="0 0 24 24">
                <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Beautiful Loading State -->
      <div class="loading-section" *ngIf="isLoading">
        <div class="loading-pulse"></div>
        <span class="loading-text">Loading workspaces...</span>
      </div>

      <!-- Elegant No Results State -->
      <div class="no-results-section" *ngIf="!isLoading && filteredWorkspaces.length === 0 && searchTerm">
        <div class="no-results-icon">
          <svg viewBox="0 0 24 24">
            <path d="M15.5,14H20.5L14.5,8H9.5C8.11,8 7,6.89 7,5.5S8.11,3 9.5,3S12,4.11 12,5.5V6H15.5C16.89,6 18,7.11 18,8.5S16.89,11 15.5,11H14L20,17L15.5,14Z" />
          </svg>
        </div>
        <div class="no-results-content">
          <h4>No workspaces found</h4>
          <p>Try different keywords or check your access</p>
        </div>
      </div>

      <!-- Load More Hint -->
      <div class="load-more-hint" *ngIf="!isLoading && hasMoreWorkspaces && filteredWorkspaces.length > 0">
        <div class="load-more-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>

  <!-- Invisible Backdrop -->
  <div class="dropdown-backdrop" [class.open]="isDropdownOpen" (click)="closeDropdown()"></div>
</div>
